import React from 'react';
import ReactDOM from 'react-dom/client';
import "./i18n";
import './index.css';
import './amplify-config';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider }from './contexts/UserContext';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Authenticator } from "@aws-amplify/ui-react";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 20 * 60 * 1000,
            gcTime: 60 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <QueryClientProvider client={queryClient}>
      <Authenticator.Provider>
          <UserProvider>
                <App />
          </UserProvider>
      </Authenticator.Provider>
      </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
